export const EXPAND_ORGANIZATION_ITEM_TAGS = ['svg', 'path'];

export const MAX_TREE_LEVEL = 10;
